import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function RubleIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M16 1C24.2843 1 31 7.71573 31 16C31 24.2843 24.2843 31 16 31C7.71573 31 1 24.2843 1 16C1 7.71573 7.71573 1 16 1ZM10.4697 7.99512V15.3555H8.71484V18.1465H10.4697V19.4346H8.71484V22.2373H10.4697V24.333H13.9668V22.2373H18.8662V19.4346H13.9668V18.1465H17.2373C18.9461 18.1464 20.3249 17.6679 21.373 16.7109C22.421 15.754 22.9453 14.5616 22.9453 13.1338C22.9453 11.7058 22.4098 10.494 21.3389 9.49902C20.2679 8.49642 18.9153 7.99512 17.2822 7.99512H10.4697ZM17.2373 11.0371C17.8751 11.0372 18.4027 11.2465 18.8203 11.6641C19.2381 12.0818 19.4473 12.61 19.4473 13.248C19.4472 13.8404 19.238 14.3419 18.8203 14.752C18.4027 15.1542 17.875 15.3554 17.2373 15.3555H13.9668V11.0371H17.2373Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
